import React, { useState, useRef, useEffect } from 'react';
import { useTranslation } from 'react-i18next';
import i18n from 'i18next';

const languageOptions = {
  en: 'English',
  es: 'Español',
  it: 'Italiano'
};

const LanguageSelector = () => {
  const { i18n: i18nInstance } = useTranslation();
  const currentLang = i18nInstance.language;
  const [dropdownOpen, setDropdownOpen] = useState(false);
  const dropdownRef = useRef(null);

  const toggleDropdown = () => setDropdownOpen((prev) => !prev);

  const changeLanguage = (lang) => {
    i18n.changeLanguage(lang);
    document.cookie = `locale=${lang}; path=/; max-age=31536000`;
    setDropdownOpen(false);
  };

  // Close on outside click
  useEffect(() => {
    const handleClickOutside = (event) => {
      if (dropdownRef.current && !dropdownRef.current.contains(event.target)) {
        setDropdownOpen(false);
      }
    };
    document.addEventListener('mousedown', handleClickOutside);
    return () => document.removeEventListener('mousedown', handleClickOutside);
  }, []);

  return (
    <div className="dropdown" ref={dropdownRef}>
      <a
        href="#"
        className="underline text-black dropdown-toggle"
        role="button"
        aria-haspopup="true"
        aria-expanded={dropdownOpen}
        onClick={(e) => {
          e.preventDefault();
          toggleDropdown();
        }}
      >
        {languageOptions[currentLang] || 'Language'}
      </a>

      <ul className={`dropdown-menu ${dropdownOpen ? 'show' : ''}`}>
        {Object.entries(languageOptions).map(([code, label]) => (
          <li key={code}>
            <button
              className={`dropdown-item ${currentLang === code ? 'active' : ''}`}
              onClick={() => changeLanguage(code)}
            >
              {label}
            </button>
          </li>
        ))}
      </ul>
    </div>
  );
};

export default LanguageSelector;
